import { Provider } from "react-redux";
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";
import React from "react";
import ReactDOM from "react-dom";

import "./css/index.css";
import * as serviceWorker from "./serviceWorker";
import App from "./App";
import store from "./store";

const hist = createBrowserHistory();

const pjson = require("../package.json");

ReactDOM.render(
  <Provider store={store}>
    <Router history={hist}>
      <App />
    </Router>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA

serviceWorker.unregister();
